import { render, staticRenderFns } from "./MealIdeasShoppingList.vue?vue&type=template&id=740c4f26&scoped=true"
import script from "./MealIdeasShoppingList.vue?vue&type=script&lang=js"
export * from "./MealIdeasShoppingList.vue?vue&type=script&lang=js"
import style0 from "./MealIdeasShoppingList.vue?vue&type=style&index=0&id=740c4f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c4f26",
  null
  
)

export default component.exports